import { jsx, jsxs } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { toolProductToSectionProduct, sectionFadeInStyle } from "./utils.js";
import { ProductGroupCarousel } from "../../ProductGroupCarousel.js";
function DailyDealsPart({
  part,
  onProductClick
}) {
  var _a, _b;
  if (isCallState(part.state)) return /* @__PURE__ */ jsx("div", { className: "concierge-loading", children: "Loading daily deals..." });
  if (isOutputState(part.state) && ((_b = (_a = part.output) == null ? void 0 : _a.deals) == null ? void 0 : _b.length) > 0) {
    const deals = part.output.deals;
    const products = deals.map((d) => toolProductToSectionProduct(d));
    const allSkus = deals.map((d) => d.sku).filter(Boolean);
    return /* @__PURE__ */ jsxs("div", { className: "concierge-product-sections", children: [
      /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: sectionFadeInStyle } }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: "concierge-section",
          style: { animation: "concierge-fade-in 0.35s ease-out both" },
          children: [
            /* @__PURE__ */ jsx("h3", { className: "concierge-section-title", children: "Daily Deals" }),
            /* @__PURE__ */ jsx(ProductGroupCarousel, { products, allStacklineSkus: allSkus })
          ]
        }
      )
    ] });
  }
  return null;
}
export {
  DailyDealsPart
};
//# sourceMappingURL=DailyDealsPart.js.map
